import {CategoryDto, ProductCreateDto, ProductImageDto, ProductUpdateDto} from "../../../api";
import ProductModalForm from "../productModalForm/productModalForm";

export default function ProductModalFormAddContainer(props: ProductModalFormAddContainerProps) {
    return <>
        <ProductModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={props.onSubmit}
            modalTitle={props.title}
            saveButtonTitle="Submit"
            initialValues={props.ProductToEdit!}
            initCategoryId={props.initCategoryId}
            categories={props.categories}
            productImages={props.productImages}
            files={props.files}
            setFiles={props.setFiles}
        />
    </>
}

interface ProductModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: ProductCreateDto | ProductUpdateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    ProductToEdit: ProductUpdateDto | null
    initCategoryId?: number[];
    categories: CategoryDto[];
    productImages: ProductImageDto[];
    files: ProductImageDto[],
    setFiles: any,
}
